import { render } from "./BarChartJ.vue?vue&type=template&id=02bdd112&scoped=true"
import script from "./BarChartJ.vue?vue&type=script&lang=ts"
export * from "./BarChartJ.vue?vue&type=script&lang=ts"

import "./BarChartJ.vue?vue&type=style&index=0&id=02bdd112&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02bdd112"

export default script